/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  onLoginAuthReset,
  onLoginAuthSubmit,
} from "../../Store/Slices/loginAuthSlice";
import {
  onGetClientMaster,
  // onGetClientMasterReset,
} from "../../Store/Slices/clientMasterSlice";
import { onGetApiConfig } from "../../Store/Slices/apiConfigSlice";
import { onTranslationSubmit } from "../../Store/Slices/translationSlice";
import PageError500 from "../../Utility/PageError/PageError";
import RouteConfiq from "../../Routing/routeConfig";
import Loader from "../../Utility/Loader/Loader";
import axiosInstanceAdmin from "../../Common/Axios/axiosInstanceAdmin";
import axiosInstanceClient from "../../Common/Axios/axiosInstanceClient";
import { AppTitle, clientType, GetImageUrl } from "../../Utility/Utility";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import { useGTM } from "../GTM";
// import CustomLoader from "../../Utility/CustomLoader/CustomLoader";

// import { onLandingHome } from "../../Store/Slices/homePageLandingSlice";

const Auth = () => {
  const dispatch = useDispatch();
  const [showError, setShowError] = useState(false);
  const [pageError, setPageError] = useState(null);
  const currentUrl = window.location.origin;
  const title = AppTitle();
  const translation = getTranslation();
  const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
  const ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;

  const homePageSlice = useSelector((state) => state.homePageSliceReducer)?.homePageData?.themeManagement?.[0];
  const clientMasterData = useSelector((state) => state.clientMasterReducer);
  const clientData = clientMasterData?.clientMasterData || [];
  const translationData = useSelector((state) => state.translationReducer);
  const loginAuthData = useSelector((state) => state.loginAuthReducer);
  const apiConfigData = useSelector((state) => state.apiConfigReducer);
  const [isMobileView] = useState(window.innerWidth <= 768);
  const { setGtm } = useGTM();
  // useEffect(() => {
  //   dispatch(onGetClientMasterReset());
  // }, []);

  // let ivkey = sessionStorage.getItem("ivkey");

  useEffect(() => {
    if (!clientData.length) {
      dispatch(onGetClientMaster({ PlatformDomainUrl: currentUrl }));
    }
    // if (clientData.length > 0 && !ivkey) {
    //   dispatch(onGetClientMaster({ PlatformDomainUrl: currentUrl }));
    // }
  }, [currentUrl]);

  useEffect(() => {
    if (!clientMasterData?.get_status_code) return;

    if (
      clientMasterData.get_status_code === "200" &&
      clientData[0]?.clientCode &&
      clientData[0]?.userType === clientType
    ) {
      // Set CSS Variables for Background Images and Colors
      document.documentElement.style.setProperty("--home-page-bg", `${clientData[0]?.imageConfiguration?.homePageBgImage ? `url(${GetImageUrl(clientData[0].imageConfiguration?.homePageBgImage)})` : 'none'}`);
      document.documentElement.style.setProperty("--myaccount-page-bg", `${clientData[0]?.imageConfiguration?.myAccountBgImage ? `url(${GetImageUrl(clientData[0].imageConfiguration?.myAccountBgImage)})` : 'none'}`);
      //document.documentElement.style.setProperty("--top-offer-bg", `${clientData[0]?.imageConfiguration?.allYourCardSectionBgImage ? `url(${GetImageUrl(clientData[0].imageConfiguration?.allYourCardSectionBgImage)})` : 'none'}`);
      document.documentElement.style.setProperty("--welcomeOfferDetailColor1", clientData[0]?.imageConfiguration?.welcomeOfferDetailBgImage?.gradient1);
      document.documentElement.style.setProperty("--welcomeOfferDetailColor2", clientData[0]?.imageConfiguration?.welcomeOfferDetailBgImage?.gradient2);
      document.documentElement.style.setProperty("--welcomeOfferDetailColor3", clientData[0]?.imageConfiguration?.welcomeOfferDetailBgImage?.gradient3);
      document.documentElement.style.setProperty("--headerconfigurationborderColor", clientData[0]?.headerConfiguration?.borderColor);
      document.documentElement.style.setProperty("--headerconfigurationbgColor1", clientData[0]?.headerConfiguration?.headerBgColor?.gradient1);
      document.documentElement.style.setProperty("--headerconfigurationbgColor2", clientData[0]?.headerConfiguration?.headerBgColor?.gradient2);
      document.documentElement.style.setProperty("--headerconfigurationtextColor1", clientData[0]?.headerConfiguration?.headerTextColor?.gradient1);
      document.documentElement.style.setProperty("--headerconfigurationtextColor2", clientData[0]?.headerConfiguration?.headerTextColor?.gradient2);
      document.documentElement.style.setProperty("--headerconfigurationtextColor3", clientData[0]?.headerConfiguration?.headerTextColor?.gradient3);
      localStorage.setItem("gtmId", clientData[0]?.gtmId);
      setGtm(clientData[0]?.gtmId);
      dispatch(onLoginAuthSubmit({ accessKey: ACCESS_KEY, secretkey: SECRET_KEY }));
    } else {
      setShowError(true);
      setPageError({
        StatusCode: clientMasterData.get_status_code,
        ErrorName: translation?.internalServerError,
        ErrorDescription: translation?.noPermissionContactAdmin,
        url: "/",
        buttonText: translation?.backToHome,
      });
    }
    if (homePageSlice?.themeConfigurations) {
      document.documentElement.style.setProperty("--themeconfigurationborderColor1", homePageSlice?.themeConfigurations?.borderColor?.gradient1 || "#ffffff");
      document.documentElement.style.setProperty("--themeconfigurationborderColor2", homePageSlice?.themeConfigurations?.borderColor?.gradient2 || "#ffffff");
    }
    document.documentElement.style.setProperty("--themeconfigurationCategoryTextColor", homePageSlice?.categoryTextColor || homePageSlice?.commonElementTextColor);
    // dispatch(onGetClientMasterReset());
  }, [clientMasterData]);

  useEffect(() => {
    if (!loginAuthData?.status_code) return;

    if (loginAuthData.status_code === "200") {

      dispatch(onTranslationSubmit());
      dispatch(onLoginAuthReset());
    } else {
      setShowError(true);
    }
  }, [loginAuthData]);

  useEffect(() => {
    if (!translationData?.status_code) return;

    if (translationData.status_code === "200") {
      // if (parseInt(clientData[0]?.themeId)) {
      //   dispatch(onGetThemeMaster({ id: parseInt(clientData[0].themeId) }));
      // }
      if (!sessionStorage.getItem("setCall")) {
        dispatch(onGetApiConfig({ serviceName: "v3" }));
        if (apiConfigData.get_status_code === "200") {
          sessionStorage.setItem("setCall", "true");
        }
      }
      setShowError(false);
    } else {
      setShowError(true);
    }
    let postLoginSuccesCount = sessionStorage.getItem("postLoginSuccesCount");

    if (!postLoginSuccesCount) {
      sessionStorage.setItem("postLoginSuccesCount", 1);
    }

    document.title = title?.title;
    const link = document?.querySelector("link[rel='icon']");
    if (link) {
      link.href = GetImageUrl(title?.favIcon);
    }
  }, [translationData]);

  const authToken = loginAuthData?.data?.[0]?.token;
  const clientCode = clientData[0]?.clientCode;
  const userType = clientData[0]?.userType;

  [axiosInstanceClient, axiosInstanceAdmin].forEach((instance) => {
    instance.defaults.headers.Authorization = `Bearer ${authToken}`;
    instance.defaults.headers["Client-Code"] = clientCode;
    instance.defaults.headers["Encryption"] = 2;
    instance.defaults.headers["Partner-Code"] = userType;
  });

  // if (
  //   clientMasterData?.isgetLoading ||
  //   translationData?.isLoading ||
  //   loginAuthData?.isLoading
  // ) {
  //   return <CustomLoader/>;
  // }
  // const [nonLogin, setNonLogin] = useState(1);

  // useEffect(() => {
  //   if (clientMasterData && translationData && !loginAuthData) {
  //     setNonLogin(1);
  //   }
  //   if (loginAuthData?.data?.[0]?.token) {
  //     setNonLogin(2);
  //   }
  // }, [clientMasterData, translationData, loginAuthData]);

  if (!loginAuthData?.closeLoader) {
    return isMobileView ? null : <Loader />;
  }


  return showError ? (
    <PageError500 pageError={pageError} />
  ) : translationData?.status_code === "200" ? (
    <RouteConfiq />
  ) : null;
};

export default Auth;
